import {
  doGETRequest,
  doPOSTRequest,
  doPUTRequest,
  doDELETERequest
} from "./Api";
import { OrderShipmentActionParamsDTO } from "./dto/OrderShipmentActionParamsDTO";

class ShipmentApi {

  public static async listAll() {
    const relativePath = "/shipments";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listByStatus(status: string) {
      const relativePath = `/shipments?status=${status}`;
      return await doGETRequest(relativePath);
  }

  public static async listContentOf(orderShipmentId: Number) {
    const relativePath = "/shipments/"+orderShipmentId+"/content";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listAvailableVehicles() {
    const relativePath = "/shipments/availableVehicles";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listVehicles() {
      const relativePath = "/shipments/vehicles";
      var response = await doGETRequest(relativePath);
      return response;
  }

  public static async listFormations() {
      const relativePath ="/shipments/formations";
      var response = await doGETRequest(relativePath);
      return response;
  }

  public static async listVehicleFormationPoints(vehicleId: number) {
      const relativePath = `/shipments/vehicles/${vehicleId}/formationPoints`;
      var response = await doGETRequest(relativePath);
      return response;
  }

  public static async listDrivers() {
    const relativePath = "/shipments/vehicleDrivers";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async createOrUpdateVehicle(data: any) {
      const relativePath = "/shipments/vehicle";
      const method = data.id ? doPUTRequest : doPOSTRequest;
      var response = await method(relativePath, data);
      return response;
   }

   public static async createOrUpdateDriver(data: any) {
      const relativePath = "/shipments/vehicleDrivers";
      const method = data.id ? doPUTRequest : doPOSTRequest;
      var response = await method(relativePath, data);
      return response;
   }
  
  public static async createOrUpdate(data: any) {
    if(data.id) {
      return this.update(data);
    }
    return this.create(data);
  }
  
  public static async create(data: any) {
    const relativePath = "/shipments";
    var response = await doPOSTRequest(relativePath, data);
    return response;
  }

  public static async update(data: any) {
    const relativePath = "/shipments";
    var response = await doPUTRequest(relativePath, data);
    return response;
  }

  public static async markAsLoading(orderShipmentId: Number) {
    const relativePath = "/shipments/status/loading/"+orderShipmentId;
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async markAsCompleted(orderShipmentId: Number) {
    const relativePath = "/shipments/complete-delivery/"+orderShipmentId;
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async loadWeightCheck(orderShipmentId: Number) {
    const relativePath = "/shipments/start-load-check/"+orderShipmentId;
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async loadOrderItemToShipment(dto:any) {
      const relativePath = "/shipments/load";
      var response = await doPUTRequest(relativePath, dto);
      return response;
   }

  public static async listLoadedItems(orderShipmentId: number) {
      const relativePath = `/shipments/${orderShipmentId}/loaded-items`;
      const response = await doGETRequest(relativePath);
      return response;
  }

  public static async deleteLoadedPalletItem(dto:any) {
    const relativePath = "/shipments/delete-pallet-item";
    const response = await doPUTRequest(relativePath, dto);
    return response;
  }

  public static async listAvailableShipmentsToLoad() {
    const relativePath = "/shipments/filter-by-status?status=LOADING";
    var response = await doGETRequest(relativePath);
    return response;
  }

    public static async finishLoading(orderShipmentId: Number, confirm: boolean = false) {
     const relativePath = "/shipments/finish-loading/" + orderShipmentId + "?confirm=" + confirm;
     var response = await doPUTRequest(relativePath, {});
     return response;
    }

  public static async startDelivery(orderShipmentId: Number) {
    const relativePath = "/shipments/start-delivery/"+orderShipmentId;
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

  public static async onAction(orderShipmentId: Number, orderShipmentAction:OrderShipmentActionParamsDTO) {
    const relativePath = "/shipments/"+orderShipmentId+"/on-action";
    var response = await doPUTRequest(relativePath, orderShipmentAction);
    return response;
  }

  public static async listCities() {
      const relativePath = "/shipments/cities";
      var response = await doGETRequest(relativePath);
      return response;
  }

  public static async listOrderItemsForPlanning() {
      const relativePath = `/shipments/planning-items`;
      return await doGETRequest(relativePath);
  }

  public static async listOrderGroupedItemsForPlanning() {
        const relativePath = `/shipments/planning-items-grouped`;
        return await doGETRequest(relativePath);
  }

  public static async listOrderShipmentsForPlanning() {
        const relativePath = `/shipments/planning-order-shipments`;
        return await doGETRequest(relativePath);
  }

  public static async listContentOfShipment(shipmentId: number) {
      // Yeni yazdığımız endpoint
      const relativePath = `/shipments/planning/${shipmentId}/details`;
      return await doGETRequest(relativePath);
  }


  public static async assignOrderItemToShipment(payload: {
    orderItemId: number;
    shipmentId: number;
  }) {
    const relativePath = `/shipments/planning/assign`;
    return await doPOSTRequest(relativePath, payload);
  }

  public static async deassignOrderItemFromPlanning(planningId: number) {
    // Backend'deki @DeleteMapping("/planning/deassign/{planningId}") adresine gider
    const relativePath = `/shipments/planning/deassign/${planningId}`;
    return await doDELETERequest(relativePath,"");
  }

  public static async updatePlannedPalletIndex(planningId: number, palletIndex: number | null) {
    // Not: Eğer bir ürünü paletten çıkarmak istersen palletIndex değerini null gönderebilirsin.
    const dto = {
      planningId: planningId,
      palletIndex: palletIndex
    };
    const relativePath = '/shipments/planning/update-pallet';

    // Projendeki API çağırma yapısına göre (post, put veya patch) düzenleyebilirsin.
    // Genelde güncelleme işlemleri için 'put' kullanılır.
    return await doPUTRequest(relativePath, dto);
  }

    public static async assignOrderGroupToShipment(payload: {
      shipmentId: number;
      ordersId: number;
    }) {
      const relativePath = `/shipments/planning/assign-group`;
      return await doPOSTRequest(relativePath, payload);
    }

    public static async deassignOrderGroupFromShipment(
      shipmentId: number,
      ordersId: number
    ) {
      const relativePath = `/shipments/planning/deassign-group/${shipmentId}/${ordersId}`;
      return await doDELETERequest(relativePath, "");
    }

    public static async confirmShipmentPlan(shipmentId: number) {
        // Backend: @PostMapping("/planning/confirm/{shipmentId}")
        const relativePath = `/shipments/planning/confirm/${shipmentId}`;
        return await doPOSTRequest(relativePath, {});
    }

    public static async unconfirmShipmentPlan(shipmentId: number) {
        // Backend: @PostMapping("/planning/unconfirm/{shipmentId}")
        const relativePath = `/shipments/planning/unconfirm/${shipmentId}`;
        return await doPOSTRequest(relativePath, {});
    }
    public static async getShipmentWaypoints(shipmentId: number) {
        const relativePath = `/shipments/${shipmentId}/waypoints`;
        return await doGETRequest(relativePath);
    }

}

export default ShipmentApi;
